<template>
  <div class="page-payment-success">
    <van-row justify="space-between">
      <van-col span="24">
        <div class="payment-box">
          <div class="payment-icon">
            <van-icon
              name="success"
              color="#fff"
              size="40"
              class="icon-success"
            />
          </div>
          <div class="payment-title">
            <p class="pm-title" style="margin-bottom: 15px">
              {{ $t("successfully") }}
            </p>
            <!--
            <p
              class="pm-title-sub"
              style="text-align: center; max-width: 330px"
            >
              {{ $t("tv360.success_message") }} {{ data.packageName }}
            </p>
            -->
            <p
              class="pm-title-sub"
              style="text-align: center; max-width: 330px"
            >
              {{ $t("tv360.success_message_all") }}
            </p>
          </div>
        </div>
      </van-col>
      <van-col span="24">
        <div class="payment-content">
          <div class="page-wapper">
            <div class="wapper-content">
              <div class="content">
                <ul>
                  <li class="sub_title">{{ $t("subscribe_id") }}</li>
                  <li>{{ data.subcribeId }}</li>
                </ul>
                <ul>
                  <li class="sub_title">{{ $t("subscribe_date") }}</li>
                  <li>{{ data.subcribeDate }}</li>
                </ul>
                <ul>
                  <li class="sub_title">{{ $t("tv360.paid_to") }}</li>
                  <li>{{ formatPhoneNumberWith855(data.paidTo) }}</li>
                </ul>
                <ul>
                  <li class="sub_title">{{ $t("total_amount") }}</li>
                  <li>{{ data.unit }} {{ fixedPrice(data.price) }}</li>
                </ul>
                <div>
                  <hr class="card-line" />
                  <div class="card-description">
                    <div
                      class="package-benefits-html"
                      style="padding-bottom: 2px"
                      v-html="data.fullDes"
                    ></div>
                  </div>
                  <div class="card-description">
                    <div
                      class="package-benefits-html"
                      style="font-weight: 500; color: #000"
                    >
                      {{ $t("tv360.success_message2") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="footer-bill" style="">
                <img
                  id="img-footer-bill"
                  src="@/assets/images/buttomCut.svg"
                  style=""
                  alt="footer-bill"
                  class="img-footer-bill"
                />
              </div>
            </div>
          </div>
        </div>
      </van-col>
      <van-col
        span="24"
        class="cs-btn-bill van-payment-success"
        style="background-color: white; z-index: 999"
      >
        <van-button
          @click="goHome"
          :color="color_primary()"
          block
          class="btn-home"
        >
          {{ $t("home") }}</van-button
        >
      </van-col>
    </van-row>
  </div>
</template>

<script src="./index.js"></script>

<style src="./index.css" lang="css" scoped></style>
